import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { Constants } from '../lib/const/constants';
// import Transaction from './Transactions/Transaction';
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react';
import { CURRENCIES } from '../lib/currencies';
import WalletsSkeleton from '../components/ui/WalletsSkeleton';
import { checkForNewBackendTickets } from '../utils/ticketHelpers';
import { currencyRequest, getAllTicket } from '../api/ticketApi';
import WalletsSection from '../components/Wallets';

import DashboardTransferCalculator from './DashboardTransferCalculator';
import DashboardTransaction from './DashboardTransaction';
import DashboardDocuments from './DashboardDocuments';
import { encryptPayload } from '../utils/encryption';
import { getCountryInfo } from '../lib/currenyUtils';

function Dashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const paramsdata = location.state || {};

  const [balances, setBalances] = useState([]);
  const [balancesId, setbalancesId] = useState([]);
  const [loading, setLoading] = useState(false);
  const [accountNumber, setAccountNumber] = useState('');
  const [sortcode, setSortcode] = useState('');
  const [showBalancesTab, setShowBalancesTab] = useState(false);
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [accountName, setAccountName] = useState(false);
  const [Iban,setIban] = useState('');
  const [usedBalances, setusedBalances] = useState([]);
  // const [clearBankBalance, setclearBankBalance] = useState(0.0);
  // const [currencyCloudBalance, setcurrencyCloudBalance] = useState(0.0);
  const [openPopUp, setOpenPopUp] = useState(false);
  const [countries, setCountries] = useState([]);
  // const [clearBankConfiguration, setclearBankConfiguration] = useState();
  const [currencyLoading, setCurrencyLoading] = useState(false);
  const [addWalletCurrency, setAddWalletCurrency] = useState('');
  const [currencyDropdownOpen, setCurrencyDropdownOpen] = useState(false);
  const [showconvertTab, setshowconvertTab] = useState(false);
  const [newTicket, setNewTicket] = useState(null);
  const [reference, setReference] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [ticketPopUp, setTicketShowPopUp] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [currencyError, setCurrencyError] = useState('');

  const [dashboardTickets, setDashboardTickets] = useState([]);

  const [documents, setDocuments] = useState([]);
  const [documentsLoading, setDocumentsLoading] = useState(true);
  const [ticketsLoading, setTicketsLoading] = useState(true);

  // console.log('newww', newTicket);

  const setAsyncData = async (key, value) => {
    sessionStorage.setItem(key, value);
  };

  const getData = async () => {
    const workspace = sessionStorage.getItem('login_workspaces');
    const login_id = sessionStorage.getItem('login_id');
    const staff_login_id = sessionStorage.getItem('staff_login_id');
    const login_token = sessionStorage.getItem('login_token');
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');

    var two_fa = sessionStorage.getItem('two_fa');
    var qr_enabled = sessionStorage.getItem('qr_enabled');
    var qr_login_completed = sessionStorage.getItem('qr_login_completed');
    if (
      !Object.prototype.hasOwnProperty.call(paramsdata, 'qr_login_completed')
    ) {
      navigate('/business');
    }
    if (two_fa == 1 && qr_enabled == 0) {
      navigate('/business');
    } else if (two_fa == 1 && qr_enabled == 1) {
      if (qr_login_completed == 1 || paramsdata.qr_login_completed == 1) {
        console.log('success');
      } else {
        navigate('/business');
      }
    }

    setAsyncData('balances', '');
    setAsyncData('conversions', '');
    await axios
      .get(
        Constants.BASE_URL +
          'API-FX-165-CCTRANSACTIONS/' +
          login_workspaces_id +
          '?page=1&from=1970-01-01&to=1970-02-01',
        {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(login_token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      )
      .then((resp) => {
        // console.log('menu tabs' + JSON.stringify(resp.data.menu));
        if (resp.data.menu.length > 0) {
          for (var m = 0; m < resp.data.menu.length; m++) {
            if (resp.data.menu[m].tab_id == 2) {
              setAsyncData(
                'balances',
                JSON.stringify(resp.data.menu[m].tab_id),
              );
            }
            if (resp.data.menu[m].tab_id == 1) {
              setAsyncData(
                'conversions',
                JSON.stringify(resp.data.menu[m].tab_id),
              );
            }
          }
          setLoading(false);
          return true;
        } else {
          setLoading(false);
          setAsyncData('balances', '');
          setAsyncData('conversions', '');
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });

    const balancestab = sessionStorage.getItem('balances');
    // console.log('balancestab' + balancestab);
    if (balancestab) {
      setShowBalancesTab(true);
    }

    if (workspace) {
      const defaultBank = sessionStorage.getItem('defaultBank');
      const parsedWorkspace = JSON.parse(workspace);
      if (defaultBank === 'Clear Bank as Service') {
        setAccountNumber(
          sessionStorage.getItem('clearBankCustomerWalletNumber'),
        );
        setSortcode(sessionStorage.getItem('clearBankCustomerSortCode'));
        setAccountName(parsedWorkspace[0].name);
        setIban(sessionStorage.getItem('clearBankCustomerIBAN'))
      } else {
        if (Object.keys(parsedWorkspace[0].accounts).length > 0) {
          setAccountNumber(parsedWorkspace[0].accounts.meta.account_number);
          setSortcode(parsedWorkspace[0].accounts.meta.routing_code);
          setAccountName(parsedWorkspace[0].name);
        } else {
          if (parsedWorkspace[0].type != 'business') {
            setAccountNumber(
              Constants.ACCOUNT_DETAILS[0].GBP[0]['Account Number'],
            );
            setSortcode(Constants.ACCOUNT_DETAILS[0].GBP[0]['Sort Code']);
            setAccountName('FXMaster');
            setReference(
              JSON.parse(sessionStorage.getItem('login_workspaces'))[0]
                .memberships.urn,
            );
          }
        }
      }
    }

    if (!login_id || !login_token) {
      if (staff_login_id === '' || staff_login_id == null) {
        sessionStorage.clear();
        navigate('/business');
      } else {
        navigate('/DebitTransactions');
      }
    }
  };

  const getBalances = async (currency = '') => {
    if (balanceLoading) return;
    setBalanceLoading(true);
    setBalances([]);
    setOpenPopUp(false);
    // console.log('loading getbalances');
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    const login_token = sessionStorage.getItem('login_token');

    if (!login_workspaces_id) {
      const staff_login_id = sessionStorage.getItem('staff_login_id');
      if (staff_login_id === '' || staff_login_id == null) {
        navigate('/business');
      } else {
        navigate('/DebitTransactions');
      }
    } else {
      try {
        var balanceUrl =
          Constants.BASE_URL +
          'API-FX-231-GET-WALLET-BALANCES/' +
          login_workspaces_id;
        if (currency != '')
          balanceUrl =
            Constants.BASE_URL +
            'API-FX-231-GET-WALLET-BALANCES/' +
            login_workspaces_id +
            '?currency=' +
            currency;
        const resp = await axios.get(balanceUrl, {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(login_token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        });

        const balArray = Object.values(resp.data);
        setusedBalances(resp.data.used_balances);
        balArray.pop();
        // setcurrencyCloudBalance(resp.data.currency_cloud_account_balance);
        // setclearBankBalance(resp.data.clear_bank_account_balance);
        // setclearBankConfiguration(resp.data.fees_configuration);
        balArray.pop();
        balArray.pop();
        balArray.pop();
        // console.log('clearbank' + clearBankBalance);
        // console.log('currency' + currencyCloudBalance);
        // console.log('clearBankConfiguration' + clearBankConfiguration);

        setBalances((balances) => [...balances, ...balArray]);

        const gbpBalance = balArray.find(
          (balance) => balance.currency === 'GBP',
        );
        if (gbpBalance) {
          console.log('babbbb' + gbpBalance.balance);
        }
        if (currency != '') location.reload();

        const balId = [];
        balArray.map((bal) => {
          balId.push(bal.currency);
        });
        setbalancesId(balId);
      } catch (err) {
        console.log(err.response.data);
      } finally {
        setBalanceLoading(false);
      }
    }
  };

  useEffect(() => {
    const shouldInit = sessionStorage.getItem('shouldInitOneSignal');
    const workspaceId = sessionStorage.getItem('login_workspaces_id');
    if (shouldInit === 'true') {
      if (window.OneSignalInitialized) {
        // console.log('Already initialized');
        return;
      }
      window.OneSignalInitialized = true;
      const OneSignal = window.OneSignal;
      OneSignal.init({
        appId: '64a19a93-b7c2-412b-8afa-4303907b7f4b',
        serviceWorkerPath: '/OneSignalSDKWorker.js',
      })
        .then(async () => {
          await OneSignal.Notifications.requestPermission();
          // console.log('🔔 Permission requested');
          if (workspaceId) {
            await OneSignal.login(workspaceId.toString());
            // console.log('Logged in with external ID:', workspaceId);
          } else {
            console.error('workspaceId not found in sessionStorage');
          }
        })
        .catch((error) => {
          console.error('Initialization error:', error);
        });
    }
  }, []);

  useEffect(() => {
    getData(0);
    getBalances();
    setLoading(true);
    convertTab();
    checkNew();
    fetchDashboardTickets();
    fetchDashboardDocuments();
  }, []);

  const checkNew = async () => {
    const workspace_id = sessionStorage.getItem('login_workspaces_id');
    const ticket = await checkForNewBackendTickets(workspace_id);
    // console.log('tttttt', ticket);
    if (Array.isArray(ticket) && ticket.length > 0) {
      setNewTicket(ticket);
      setTicketShowPopUp(true);
    }
  };

  const fetchDashboardTickets = async () => {
    const workspace_id = sessionStorage.getItem('login_workspaces_id');
    try {
      const data = await getAllTicket(workspace_id);
      setDashboardTickets(data.results || []);
    } catch (err) {
      console.log('dashboard tickets error', err);
    } finally {
      setTicketsLoading(false);
    }
  };

  const fetchDashboardDocuments = async () => {
    const login_id = sessionStorage.getItem('login_id');
    const login_token = sessionStorage.getItem('login_token');
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');

    if (!login_id || !login_token) {
      setDocumentsLoading(false);
      return;
    }

    const from =
      new Date().getFullYear() +
      '-' +
      (new Date().getMonth() + 1) +
      '-' +
      (new Date().getDate() - 100);
    const to =
      new Date().getFullYear() +
      '-' +
      (new Date().getMonth() + 1) +
      '-' +
      new Date().getDate();

    try {
      const geturl =
        `${Constants.BASE_URL}API-FX-180-CONVERSIONLIST/${login_workspaces_id}` +
        `?page=0&from=${from}&to=${to}&transactionId=&date=&sender=&sendingAmount=&receivingAmount=&status=`;

      const response = await axios.get(geturl, {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(login_token),
          fx_key: Constants.SUBSCRIPTION_KEY,
        },
      });

      setDocuments(response.data.typeOfDocuments || []);
    } catch (err) {
      console.log('dashboard documents error', err);
    } finally {
      setDocumentsLoading(false);
    }
  };

  const addWallet = async () => {
    setOpenPopUp(true);
    setCurrencyLoading(true);
    setCountries(Constants.INDIVIDUAL_CURRENCIES);
    if (reference == '') {
      const token = sessionStorage.getItem('login_token');
      await axios
        .get(Constants.BASE_URL + 'API-FX-162-CONVERTCOUNTRIES', {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        })
        .then((resp) => {
          setCountries(resp.data.buying_currencies);
          setCurrencyLoading(false);
        })
        .catch(() => {
          setCurrencyLoading(false);
        });
    } else {
      setCurrencyLoading(false);
    }
  };

  const onClose = async () => {
    setCurrencyError('');
    setOpenPopUp(false);
  };

  const proceedToAddWallet = async () => {
    if (!addWalletCurrency) {
      setCurrencyError('Please select a currency before adding.');
      return;
    }
    setCurrencyError('');
    try {
      const token = sessionStorage.getItem('login_token');
      const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
      const encryptedPayload = await encryptPayload({
          balance: 0,
          currency: addWalletCurrency,
          workspace_id: login_workspaces_id,
          payment_gateway: 'currency_cloud',
          platform: 'web',
          extraParamValidation: 'trustedfromweb'
        });
      await axios.post(
        Constants.BASE_URL + 'API-240-ADD-CURRENCY-WALLET',
        encryptedPayload,
        {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      );
      if (typeof getBalances === 'function') {
        await getBalances();
      }
      onClose();
    } catch (error) {
      setCurrencyError(error?.response?.data || 'Something went wrong.');
    }
  };

  const convertTab = async () => {
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    var login_token = sessionStorage.getItem('login_token');
    await axios
      .get(
        Constants.BASE_URL +
          'API-FX-165-CCTRANSACTIONS/' +
          login_workspaces_id +
          '?page=1&from=1970-01-01&to=1970-02-01',
        {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(login_token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      )
      .then((resp) => {
        // console.log('menu tabs' + JSON.stringify(resp.data.menu));
        if (resp.data.menu.length > 0) {
          for (var m = 0; m < resp.data.menu.length; m++) {
            if (resp.data.menu[m].tab_id == 1) {
              setshowconvertTab(true);
            }
          }
          return true;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getUserTypeFromSession = () => {
    const raw = sessionStorage.getItem('login_workspaces');
    if (!raw) return null;
    try {
      const parsed = JSON.parse(raw);
      return parsed?.type || parsed?.[0]?.type || null;
    } catch (err) {
      console.error('login_workspaces parse error:', err);
      return null;
    }
  };

  const userType = getUserTypeFromSession();

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 17) return 'Good Afternoon';
    return 'Good Evening';
  };
  const fullName = sessionStorage.getItem('login_workspace_name') || '';
  // const firstName = fullName.split(' ')[0] || '';

  const statusColors = {
    Open: {
      bg: '#dcfce7',
      color: '#166534',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0px',
    },
    'In Progress': {
      bg: '#dbeafe',
      color: '#1447E6',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0px',
    },
    Pending: {
      bg: '#fef9c3',
      color: '#92400e',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0px',
    },
    Closed: {
      bg: '#f3f4f6',
      color: '#64686f',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0px',
    },
  };
  const availableCurrencies = countries.filter(
  (c) => !balancesId.includes(c.currency)
);

  const hasTickets =
    Array.isArray(dashboardTickets) && dashboardTickets.length > 0;
  const hasDocuments = Array.isArray(documents) && documents.length > 0;

  return (
    <div style={{ background: '#f5f6fa', minHeight: '100vh' }}>
      <Dialog
        open={openPopUp}
        onClose={() => onClose()}
        className="relative z-10"
      >
        <DialogBackdrop className="fixed inset-0 bg-gray-500/20 transition-opacity" />
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel className="relative transform  rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
              <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4  rounded-t-lg">
                <DialogTitle className="text-lg font-medium leading-6 text-gray-900 mb-5">
                  Select Currency
                </DialogTitle>
                {currencyLoading ? (
                  'loading...'
                ) : countries.filter((c) => !balancesId.includes(c.currency))
                    .length === 0 ? (
                  <p className="text-red-500 text-sm">
                    No currencies available to add at the moment.
                  </p>
                ) : (
                 <div className="relative">
                    <button
                      type="button"
                      onClick={() => setCurrencyDropdownOpen((v) => !v)}
                      className="bg-white border border-blue text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 text-left"
                    >
                      {addWalletCurrency ? (
                        <span className="inline-flex items-center gap-2">
                          {
                            getCountryInfo(addWalletCurrency, {
                              width: 20,
                              height: 14,
                              className:
                                'w-5 h-3.5 object-cover rounded-sm flex-shrink-0',
                            }).flag
                          }
                          <span>
                            {addWalletCurrency} -{' '}
                            {CURRENCIES[addWalletCurrency]}
                          </span>
                        </span>
                      ) : (
                        'Select'
                      )}
                    </button>

                    {currencyDropdownOpen && (
                      <div className="absolute w-full mt-1 bg-white border border-blue rounded-lg shadow-md z-20 max-h-72 overflow-y-auto">
                        {countries.map(
                          (countryRow) =>
                            !balancesId.includes(countryRow.currency) && (
                              <div
                                key={countryRow.id}
                                onClick={() => {
                                  setAddWalletCurrency(countryRow.currency);
                                  setCurrencyDropdownOpen(false);
                                }}
                                className="flex items-center gap-2 px-2.5 py-2 text-sm text-gray-900 cursor-pointer hover:bg-gray-100"
                              >
                                {
                                  getCountryInfo(countryRow.currency, {
                                    width: 20,
                                    height: 14,
                                    className:
                                      'w-5 h-3.5 object-cover rounded-sm flex-shrink-0',
                                  }).flag
                                }
                                <span>
                                  {countryRow.currency} -{' '}
                                  {CURRENCIES[countryRow.currency]}
                                </span>
                              </div>
                            ),
                        )}
                      </div>
                    )}
                  </div>
                )}
                {currencyError && (
                  <p className="text-red-500 text-sm mt-1">{currencyError}</p>
                )}
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 rounded-b-lg">
                <button
                  type="button"
                  disabled={availableCurrencies.length === 0}
                  onClick={proceedToAddWallet}
                  className={`mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-gray-700 shadow-sm hover:bg-gray-100 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm ${availableCurrencies.length == 0 ? 'cursor-not-allowed' : ''}`}
                >
                  Add
                </button>
                <button
                  type="button"
                  onClick={onClose}
                  className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-gray-700 shadow-sm hover:bg-gray-100 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Cancel
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>

      {showPopup &&
        (currencyLoading ? (
          <p>Loading...</p>
        ) : countries.filter((c) => !balancesId.includes(c.currency)).length ===
          0 ? (
          <div className="p-4 border rounded shadow bg-white">
            <p className="mb-4 text-red-600">
              No additional currencies can be added at this time. If you&apos;d
              like to request a new one, please submit your request below — our
              team will review it and get back to you.
            </p>
            <form
              className="space-y-4"
              onSubmit={async (e) => {
                e.preventDefault();
                const currencyInput = e.target[0].value.trim();
                const messageInput = e.target[1].value.trim();
                const fullName =
                  sessionStorage.getItem('login_full_name') || '';
                const emailAddress =
                  sessionStorage.getItem('login_email') || '';
                const nameParts = fullName.trim().split(/\s+/);
                const firstName =
                  nameParts.length >= 2
                    ? nameParts.slice(0, -1).join(' ')
                    : fullName;
                const lastName =
                  nameParts.length >= 2 ? nameParts[nameParts.length - 1] : '';
                const errors = {};
                if (!currencyInput) {
                  errors.currency = 'Currency code is required.';
                } else if (!/^[A-Z]{3}$/.test(currencyInput)) {
                  errors.currency =
                    'Currency code must be 3 uppercase letters (e.g. GBP).';
                }
                if (messageInput.length > 500) {
                  errors.message = 'Message cannot exceed 500 characters.';
                }
                setFormErrors(errors);
                if (Object.keys(errors).length > 0) return;
                const payload = {
                  subject: currencyInput,
                  first_name: firstName,
                  last_name: lastName,
                  email: emailAddress,
                  message: messageInput,
                };
                setSubmitting(true);
                try {
                  const response = await currencyRequest(payload);
                  console.log('Request submitted:', response);
                  setShowPopup(false);
                } catch (err) {
                  console.error('Error sending request:', err);
                } finally {
                  setSubmitting(false);
                }
              }}
            >
              <div>
                <input
                  type="text"
                  placeholder="Enter currency code (e.g. GBP)"
                  className="w-full p-2 border border-gray-300 rounded"
                />
                {formErrors?.currency && (
                  <p className="text-red-600 text-sm mt-1">
                    {formErrors.currency}
                  </p>
                )}
              </div>
              <div>
                <textarea
                  placeholder="Optional message"
                  className="w-full p-2 border border-gray-300 rounded"
                />
                {formErrors?.message && (
                  <p className="text-red-600 text-sm mt-1">
                    {formErrors.message}
                  </p>
                )}
              </div>
              <div className="flex justify-end space-x-2">
                <button
                  type="button"
                  onClick={() => setShowPopup(false)}
                  className="px-4 py-2 bg-gray-300 rounded"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={submitting}
                  className={`px-4 py-2 rounded text-white font-medium ${submitting ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}`}
                >
                  {submitting ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </form>
          </div>
        ) : (
          // <select
          //   onChange={(e) => {
          //     const [currency] = e.target.value.split('_');
          //     setAddWalletCurrency(currency);
          //   }}
          //   className="bg-white border border-blue text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
          // >
          //   <option key={0} value="">
          //     Select
          //   </option>
          //   {countries.map(
          //     (countryRow) =>
          //       !balancesId.includes(countryRow.currency) && (
          //         <option
          //           key={countryRow.id}
          //           value={`${countryRow.currency}_${countryRow.id}`}
          //         >
          //           {countryRow.currency} - {CURRENCIES[countryRow.currency]}
          //         </option>
          //       ),
          //   )}
          // </select>

          <div className="relative">
            <button
              type="button"
              onClick={() => setCurrencyDropdownOpen((v) => !v)}
              className="bg-white border border-blue text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 text-left"
            >
              {addWalletCurrency ? (
                <span className="inline-flex items-center gap-2">
                  {
                    getCountryInfo(addWalletCurrency, {
                      width: 20,
                      height: 14,
                      className:
                        'w-5 h-3.5 object-cover rounded-sm flex-shrink-0',
                    }).flag
                  }
                  <span>
                    {addWalletCurrency} - {CURRENCIES[addWalletCurrency]}
                  </span>
                </span>
              ) : (
                'Select'
              )}
            </button>

            {currencyDropdownOpen && (
              <div className="absolute w-full mt-1 bg-white border border-blue rounded-lg shadow-md z-20 max-h-96 overflow-y-auto">
                {countries.map(
                  (countryRow) =>
                    !balancesId.includes(countryRow.currency) && (
                      <div
                        key={countryRow.id}
                        onClick={() => {
                          setAddWalletCurrency(countryRow.currency);
                          setCurrencyDropdownOpen(false);
                        }}
                        className="flex items-center gap-2 px-2.5 py-2 text-sm text-gray-900 cursor-pointer hover:bg-gray-100"
                      >
                        {
                          getCountryInfo(countryRow.currency, {
                            width: 20,
                            height: 14,
                            className:
                              'w-5 h-3.5 object-cover rounded-sm flex-shrink-0',
                          }).flag
                        }
                        <span>
                          {countryRow.currency} -{' '}
                          {CURRENCIES[countryRow.currency]}
                        </span>
                      </div>
                    ),
                )}
              </div>
            )}
          </div>
        ))}

      {ticketPopUp && newTicket && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <div
            style={{
              position: 'relative',
              backgroundColor: '#fff',
              padding: '20px 25px',
              borderRadius: '10px',
              boxShadow: '0 0 10px rgba(0,0,0,0.3)',
              width: '60%',
              maxWidth: '600px',
              maxHeight: '60vh',
              overflowY: 'auto',
            }}
          >
            <button
              onClick={() => setTicketShowPopUp(false)}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                backgroundColor: '#f87171',
                color: '#fff',
                border: 'none',
                padding: '5px 10px',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = '#ef4444')
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = '#f87171')
              }
            >
              Close
            </button>
            <h2
              style={{
                textAlign: 'center',
                marginBottom: '15px',
                fontSize: '18px',
              }}
            >
              <strong>New Tickets Assigned</strong>
            </h2>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: '14px',
              }}
            >
              <thead>
                <tr style={{ backgroundColor: '#f0f0f0' }}>
                  <th style={{ padding: '8px', border: '1px solid #ccc' }}>
                    Title
                  </th>
                  <th style={{ padding: '8px', border: '1px solid #ccc' }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {newTicket.map((ticket) => (
                  <tr key={ticket.id}>
                    <td style={{ padding: '8px', border: '1px solid #ccc' }}>
                      {ticket.title}
                    </td>
                    <td style={{ padding: '8px', border: '1px solid #ccc' }}>
                      <button
                        onClick={() => {
                          setTicketShowPopUp(false);
                          navigate(`/ticketdetails/${ticket.id}`);
                        }}
                        className="bg-blue-600 text-white px-2 py-1 rounded hover:bg-green-700"
                        style={{ marginRight: '8px' }}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div
        style={{
          padding: '28px 32px 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <h1
            style={{
              fontSize: '32px',
              fontWeight: 700,
              color: '#394784',
              margin: 0,
              lineHeight: '48px',
              letterSpacing: '0px',
            }}
          >
            Welcome Back,
          </h1>
          <p
            style={{
              fontSize: '16px',
              color: '#6A7282',
              fontWeight: 400,
              lineHeight: '48px',
              letterSpacing: '0px',
            }}
          >
            {getGreeting()}
            {fullName ? `, ${fullName}` : ''}
          </p>
        </div>

        <button
          onClick={() => navigate('/Pay')}
          className="
            w-[90px] h-[48px]
            px-5 py-3
            rounded-xl
            text-white
            text-[15px] font-bold
            cursor-pointer
            bg-[#D26521]
            shadow-[0_2px_8px_rgba(210,101,33,0.25)]
          "
        >
          Pay
        </button>
      </div>

      <div style={{ padding: '0 32px 32px' }}>
        {balanceLoading || loading ? (
          <WalletsSkeleton />
        ) : (
          showBalancesTab &&
          userType === 'business' && (
            <WalletsSection
              balances={balances}
              usedBalances={usedBalances}
              accountNumber={accountNumber}
              sortcode={sortcode}
              accountName={accountName}
              Iban={Iban}
              showActions={true}
              onAddWallet={addWallet}
              showconvertTab={showconvertTab}
            />
          )
        )}

        {!documentsLoading && hasDocuments && (
          <div style={{ marginBottom: 24, width: '100%' }}>
            <DashboardDocuments documents={documents} />
          </div>
        )}

        {!ticketsLoading && hasTickets && (
          <div style={{ marginBottom: 24, width: '100%' }}>
            <div
              style={{
                borderRadius: 16,
                border: '1px solid #e5e7eb',
                overflow: 'hidden',
                boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div
                style={{
                  background: '#676F7D',
                  padding: '18px 24px',
                  flexShrink: 0,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    marginBottom: 4,
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span
                    style={{
                      fontSize: 16,
                      fontWeight: 700,
                      color: '#ffffff',
                      lineHeight: '100%',
                      letterSpacing: '0px',
                    }}
                  >
                    Tickets
                  </span>
                </div>
                <p
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: '#ffffff',
                    margin: 0,
                  }}
                >
                  You have{' '}
                  {
                    dashboardTickets.filter((t) => t.status_display === 'Open')
                      .length
                  }{' '}
                  ticket(s) that need your attention.
                </p>
              </div>
              <div
                style={{
                  background: '#ffffff',
                  flex: 1,
                  maxHeight: 234,
                  overflowY: 'auto',
                  paddingBottom: 12,
                }}
              >
                {dashboardTickets.map((ticket, i) => {
                  const sc = statusColors[ticket.status_display] || {
                    bg: '#f3f4f6',
                    color: '#6b7280',
                  };
                  return (
                    <div
                      key={ticket.id}
                      style={{
                        padding: '18px 24px',
                        borderBottom:
                          i < dashboardTickets.length - 1
                            ? '1px solid #f0f0f0'
                            : 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 16,
                      }}
                    >
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            marginBottom: 6,
                            flexWrap: 'wrap',
                          }}
                        >
                          <span
                            style={{
                              fontSize: 16,
                              fontWeight: 600,
                              color: '#101828',
                              lineHeight: '24px',
                              letterSpacing: '0px',
                            }}
                          >
                            {ticket.title || ticket.subject}
                          </span>
                          <span
                            style={{
                              background: sc.bg,
                              color: sc.color,
                              fontSize: 11,
                              fontWeight: 600,
                              padding: '2px 10px',
                              borderRadius: 6,
                              whiteSpace: 'nowrap',
                              flexShrink: 0,
                            }}
                          >
                            {ticket.status_display}
                          </span>
                        </div>
                        <div
                          style={{
                            fontSize: 12,
                            fontWeight: 400,
                            color: '#4A5565',
                            lineHeight: '24px',
                            letterSpacing: '0px',
                          }}
                        >
                          Ticket #TKT-{ticket.id}
                          {ticket.created_at &&
                            ` · ${new Date(ticket.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}`}
                        </div>
                      </div>
                      <button
                        onClick={() => navigate(`/ticketdetails/${ticket.id}`)}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#306ACE',
                          fontSize: 13,
                          fontWeight: 600,
                          cursor: 'pointer',
                          padding: '4px 0',
                          flexShrink: 0,
                        }}
                      >
                        View
                      </button>
                    </div>
                  );
                })}
              </div>
              <div
                style={{
                  padding: '14px 24px',
                  textAlign: 'right',
                  borderTop: '1px solid #f0f0f0',
                  background: '#ffffff',
                  flexShrink: 0,
                }}
              >
                <button
                  onClick={() => navigate('/contactsupport')}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#306ACE',
                    fontSize: 14,
                    fontWeight: 600,
                    cursor: 'pointer',
                    padding: 0,
                  }}
                >
                  View All Tickets →
                </button>
              </div>
            </div>
          </div>
        )}

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 24,
            alignItems: 'stretch',
            height: 520,
          }}
        >
          <div
            style={{
              background: '#ffffff',
              borderRadius: 16,
              boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
              overflow: 'hidden',
            }}
          >
            <DashboardTransaction onDocumentsLoaded={() => {}} />
          </div>

          <div style={{ height: '100%' }}>
            <DashboardTransferCalculator />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
